const InfoModuleHeader = ({ header }: { header: string }) => {
  return (
    <h3 className="font-[600] tracking-[0.12em] leading-[30.6px] ">{header}</h3>
  );
};

export default InfoModuleHeader;
